var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M.3 0h33.4v16.7H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.3,
    d: "M34.7 25.7h-.1c-.3 0-.6 1-.8 1.5l-.7 1-.1.4q-.6.3-.5.8v.3l.3.7c.3.7.8 1.7 1 1.8q.9.1 2.2-1 2.1 1 4.4 1 2.6-.1 4.4-1c.7.7 1.7 1.1 2 1s.8-1.1 1.1-1.8l.3-.7v-.3q.1-.4-.4-.8l-.1-.3-.7-1.1c-.2-.5-.6-1.4-.8-1.4-.4-.1-1.1 0-1.1.1l-1.5 1.6s.1 1.2.4 2.2a10 10 0 0 1-7.2 0q.3-1 .3-2.2L35.7 26q-.2-.2-1-.3Zm.4 2q.3 0 .5.3v.1l-.2.9-1-.8q.2-.4.7-.5Zm10.6 0q.4.1.7.5l-1 .8-.3-1zm-12 2.2.8.5-.2.2h-.4V30zm13.3 0v.2l-.1.4h-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.8 28.3s-.5-1-.9-.9-.8.7-.8.7l-.7-.8s.7-1.7 1-1.8l1.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37 27.3s-.2 2.5-1 3.4c-.6.8-1.8 1.4-2.3 1.2s-1.4-2.6-1.4-2.6 1 1.2 1.8 1 1.2-1.7 1.4-2.4v-2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.7 28.3s.6-1 1-.9.8.7.8.7q.4-.3.6-.8s-.6-1.7-1-1.8l-1 .2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.6 27.3s.2 2.5 1 3.4c.6.8 1.8 1.4 2.3 1.2s1.3-2.6 1.3-2.6-1 1.2-1.7 1c-.8-.2-1.2-1.7-1.4-2.4v-2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m33.8 27.2-.7 1q-.1.4.3 1.2c.3.6 3.2 2.8 7 2.8a10 10 0 0 0 7-2.8q.5-.8.3-1.1l-.7-1.1c0 .7-2.4 3.2-6.6 3.2s-6.6-2.5-6.6-3.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m46.8 31.6.7-1.3-.4-.3-.5.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M47.4 31.2s.1-.6-.3-.6l-.5.1q.2-.1.3-.8v-1s.2-.6.7-.5c.6 0 .7.6.7.8v.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.3 29.3v.2h.2v-.3l.4.7v.1l.3-.2H46l-.4-.7.2-.1v.1h.2l-.2-.3zm-1 .6h.2l.3.8v.1l.3-.2-.2-.4.3-.2.2.3-.1.1v.1l.4-.2h-.1l-.4-.8v-.1l-.3.2h.1l.2.3-.4.2-.1-.3v-.1zm-.1.6.1.4q-.4 0-.5-.3 0-.5.2-.6h.1l.1.2h.1v-.3H44q-.5.3-.4.8.2.4.6.3l.3-.2-.1-.3v-.1zm-.8.9.4-.2h-.1l-.3-.8.1-.1h-.4v.1h.1l.3.8h-.1zm-2.1.3h.6v-.3.2h-.4v-.4h.1v.1h.2V31h-.1v.1h-.2v-.3h.3v-.2l-.6.1v.1zm-1-1v1.1h.3v-.5h.3v.3h-.1v.1h.3v-1h-.3v.4h-.3v-.3zm-.9 0v.3h.1v-.2h.2v.9h.3-.1v-1h.1v.1l.1.2v-.3zm-1.2.9h.7v-.3.2h-.4v-.4h.2v.1l.1-.3-.1.1h-.2v-.4h.3v.2h.1v-.2h-.6zm-1.5-.5.4.2v-.1H37l.2-.9h.1L37 30v.1zm-.6-.2h.2q.3.2.4-.1v-.3l-.2-.1v-.2q0-.2.1-.1h.1v.2l.1-.2-.2-.1q-.2 0-.3.2v.2l.1.2.1.2h-.3v-.2zm-.9-.4.7.3v-.2h-.4l.2-.5.1.1v.2l.2-.3h-.3l.1-.4.3.2v.1l.1-.2-.6-.3v.1l-.2.8h-.1m0-1.3-.4-.2v.1l-.3.7h-.1l.3.3.3.1.3-.2q.2-.5-.1-.8m-.2 0q.4.3.1.6-.2.4-.4.2zm2.5 1.1v.1l-.1.8h-.1v.1l.3.1v-.5q.3 0 .2.3v.2l.2.1h.1l-.1-.2V31l-.2-.2q.3 0 .3-.2t-.3-.3zm.2.1q.3 0 .2.3t-.2.2zm4.5.1v.1h.1l.2.8h-.1v.2l.4-.1h-.1v-.1l-.1-.3.3.1v.2h.4q-.2 0-.2-.2h-.5l.2-.3q0-.3-.4-.2zm.3 0q.3 0 .3.2t-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m33.8 31.6-.7-1.3.4-.3.5.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.2 31.2s-.1-.6.2-.6.6.3.6.1q-.2-.1-.4-.8v-1s0-.6-.7-.5-.6.6-.6.8v.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0072c4",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M40.4 29.7s-6.9-2.3-6.8-10.8V7.6h13.5v11.2a11 11 0 0 1-6.8 10.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    fillRule: "evenodd",
    d: "m34.5 10.3.2-.2.3-.2.3-.1.3-.2V9l.3-.1.3-.2h.4l.3.1.4.3.2.2.3.2.3.2.2.3.3.2.4.1h.7l.4.1h3.3l.4.2h.2l.3.3.3.4.1.4v.5l.1.4v.5l-.1.4v.9l-.1.4-.2.5-.3.3v.8l.2.4H44v-.4l-.2-.4q0-.2-.2-.2l-.3-.1q-.2 0-.2.2v.4l-.1.4-.3.3-.2.1-.2-.2q.2 0 .2-.3l.2-.3-.2-.3-.1-.4-.4-.1-.3.1h-.4l-.4.1h-1l-.4-.1H39q0 .3-.3.4v.4l-.2.3v.4q0 .3-.2.2l-.2-.3v-.5q0-.2-.1 0v.4l-.1.1-.2.1-.2.3V16q0-.2-.3-.2l-.3-.2-.2-.2q-.2 0-.3-.2l-.2-.3-.1-.4V14l-.2-.4v-.5l-.1-.4v-.9l-.1-.4q0-.2-.2-.2l-.3.2-.4-.1-.3-.2-.1-.2v-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    fillRule: "evenodd",
    d: "m36.2 11.5.2-.2.2-.1.2-.2.2-.2h.5l.2-.3v-.1l-.1.2-.2.3-.2.2-.1.2v.1h.2l.2-.3.1-.2q.2 0 .2-.2l.2-.1.2-.1-.1.2v.3l.1.2v-.4.3l.1.3.1.1v-.3.3l.2.3.1-.5v-.2.2-.2l.1.3v.3l.2-.2.1-.3-.1.3.1-.3v.9l.1.2.1-.2v-.4.1l.1.3v.2l.2-.2.1-.2.1-.2v-.4l.1-.3.1.1v.3l.2.3.1.2v.3l.1-.4v-.6q-.1 0 0-.1h.2v.2l.1.3.1.2.2-.2v-.2l.1.3v.3l.2.1v-1l.1.3.1-.2h.1v.4l.2.3.1.2h.2v-.4l-.1-.3v-.2l.1.3.2.3.1.2.2.2h.1v-.6q-.2 0-.3-.2v-.1l.3.3.1.2h.3q0 .2.2.2l-.2-.1.2.1-.2-.3-.1-.3-.2-.2-.2-.2h.3q0 .3.2.3l.1.4.3.1v-.1l.3.1h.1l-.1-.3-.2-.2-.1-.2v.2-.2l.2.1.2.2.1.2.2.1.1.3v.3l-.1-.1v.5l-.1-.1q0-.2-.2-.2l.1.4v1.9-.3.3-.3l-.2-.3v-.3l-.2-.1v.4l.1.3v.5l-.1.2-.2-.3v-.4l-.2-.2-.2-.3-.1-.2h-.1v.9-.4l-.2-.3-.1-.2v-.1.5l-.1-.5-.2-.3-.2-.1-.1-.1v.3l.1.3v-.1l-.1-.3-.2-.2v1.2-.2q-.2-.1-.2-.3h-.2v.3q0-.2-.2-.2l-.1-.2v-.3l-.3.1v.8l-.1.3h-.1v-1.1l-.2-.1v1.2q-.2 0-.3-.2h-.3l-.1-.1-.1-.4-.1-.3-.1-.2v.4l-.1.2-.1-.3q0-.2-.2-.2l-.1.2.1.3v.5l-.2-.4h-.3v.2q-.1 0 0 .2l-.2.2-.4-.1-.1.1h-.3l-.2.1h-.5l.1-.2.2-.2.2-.2.1-.2.3.1h.2l.3-.2h.2q0-.2.2-.3v-.3h-.2q0 .2-.2.3h-.5l-.3.1.3-.1.2-.2.2-.1q0-.2-.2 0h-.5l.2-.2h-.3l-.3.1h-.5l-.1-.2.2-.1.2-.1q.2 0 .1-.1h-.2v-.1h.3l.2-.1.2-.2.2-.2.2-.2v-.1l-.2.1-.2.2H37v-.2h-.5l-.2-.1.3-.1.1-.2zm-1.7-.5v-.7l.2-.2.3-.2.3-.1.3-.2V9l.3-.1.3-.2h.4l.3.1.4.3.2.2.3.2q0 .3-.2.2l-.2-.2v.2h-.1v-.3q-.2-.1-.2 0v.3h-.5v.1l.3.2h.7v.2l-.2.1-.3.1-.2.1q0 .3-.2.2h-.3v-.3q0 .3-.2.3v-.3H36v.1h-.4l-.2-.2-.2.2H35q-.1 0 0 0v.1h.5v.2h-.7l.3.2v.1zq.2-.1-.1-.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    fillRule: "evenodd",
    d: "m35 10.2-.3.3h.2l.2-.2zM36 9l.1.2.1-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c2",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.5 10v-.2l.2-.1h.2l.2.2H36l-.3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    fillRule: "evenodd",
    d: "M36.4 9.1v.4l.2-.2q0-.2-.2-.2m.7 2.7h.1l.2-.2.3-.2h.1l-.1.2-.2.1-.1.1zm.4.7.2-.3.2-.2.2-.2.1-.3v.6l-.2.2-.2.1-.2.1zm-.6.5.3-.2.3-.1q.2 0 0 .2h-.1l-.3.2zh.1zm.8 0 .3-.2.2-.2v.3l-.2.2-.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.8 10h-.2v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005120",
    fillRule: "evenodd",
    stroke: "#002b0d",
    strokeWidth: 0.2,
    d: "M36 16.3h.1l.4.4q0-.3.3.1 0 .2.2-.2 0 .7.3.4h.7c.1.4 0 0 .2.2l.8-.5c.2.4.3.1.6 0 .2 0 .4.4.5 0q.2-.4.3 0 .2.2.4-.2.3.3 1 .1 0 .4.3.1.4.3 1 0 0-.3.2.2h.5q.5.1.5-.4.2.4.5.1h.5c.1.3.2 0 .4.2l-.6.7q-.2.6-.6.8l-.7.7h-4.5q-.4.3-1 .3h-1q-.2-.4-.6-.7l-.3-.7-.4-.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005120",
    fillRule: "evenodd",
    d: "m43.8 17.2-.1.5-.3.1m-.3-.2-.5.8zq-.5.3-.6.8m-.6-1.3-.1.5Zm-1 0h.1m-4.5 0 .4.6v.8m.3-.8.4.5zl.4.5v.1-.7q.3.4.3.1l1-.2v.2m5.5-.4-.3.6m-3-.9h.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#002b0d",
    strokeWidth: 0.2,
    d: "m43.8 17.2-.1.5-.3.1m-.3-.2-.5.8zM42 17l-.1.5m-.2.1v.1m-.7-.6zm0 0Zm-4.5 0 .4.5v.8m.7-.3-.4-.5zm0 0v.1-.7q.3.4.3.1l1-.2v.2m5.5-.4-.3.6m-3-.9h.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.8 17.9c-1 0-1.3 1-2.2 1v2.3c1 0 1.3-1 2.2-1s1.3 1 2.3 1 1.2-1 2.2-1 1.3 1 2.2 1 1.3-1 2.3-1 1.2 1 2.1 1l.2-2.2c-1 0-1.4-1.1-2.3-1.1-1 0-1.3 1-2.3 1s-1.2-1-2.2-1-1.3 1-2.2 1-1.3-1-2.3-1m0 4.4c-.7 0-1 .6-1.7 1l.8 1.6q.3-.4 1-.4c.9 0 1.2 1.1 2.2 1.1s1.2-1 2.2-1 1.3 1 2.2 1 1.3-1 2.3-1q.5 0 1 .3l.6-1.7c-.5-.3-.9-1-1.6-1-1 0-1.3 1.2-2.3 1.2s-1.3-1.1-2.2-1.1-1.3 1-2.2 1-1.3-1-2.3-1m4.5 4.3c-1 0-1.3 1.2-2.2 1.2s-1.3-1-2.1-1.2q1.4 1.8 3.2 2.8c.3-.3.7.3 1 .3.5 0 .8-.6 1.1-.3a11 11 0 0 0 3.3-2.7c-.8.1-1.2 1-2 1-1 0-1.3-1-2.3-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m34.4 22.4.9-.4 1.5 1.7-1.2.3zm2.9 2.6.6-2.5m-.4 2.6.5-2.6m-.4 2.6.5-2.6m-.8 2.2.4-.1m-.3-.2.4-.1m-.3-.2.3-.1m-.3-.3h.4m-.2-.3h.2m-.1-.3h.2m3.4 3.6c0-.7-.7-4.5-.7-4.5m.5 4.3-.6-4.2m.3 3.9-.4-4m1 4-.6-.4m.3-.3-.4-.2m.4-.3-.4-.2m.3-.5h-.4m.2-.5h-.3m.2-.5h-.2m3.1 2c0-.5-.8-3.3-.8-3.3m.5 3.2-.6-3.1m.3 2.9-.4-3m1 3-.6-.3m.4-.3-.4-.1m.3-.2-.4-.2m.3-.3H43m.2-.4H43m.2-.4h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M40 25.6v-7.7h.3v7.7zm2.6-7.3v6.4l-.3.3.1-6.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M37.1 24.3s.3 3.2 3.3 3c3 0 3.8-3 3.8-3l-1.3-.1s-1 1.4-2.3 1.4c-1.4 0-1.8-.4-2-.7L38 24l-1.5-.7v.7zm8.1-.3v-1l-2.2.4v.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m37 24.3.7.2.6 1m6.5-2.3v.7h.3v-.7zm-.4 0v.7h.2v-.6zm-.4.7v-.5h.3v.4zm-.4 0v-.5h.3v.6zm-.5 0v-.4h.3v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M37.4 24.4s.6 2.1 3.1 2.1 3.1-2.3 3.1-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M44 24.2s-1.2 3.1-3.5 2.9-2.7-1.2-2.8-1.8l-.3-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M38 24.1v-5.7V24l.1.1Zm-3.7-1.8 2 1.1v.2l-2-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m35.2 22 .5 2-.3-2zm1.8 0 2-.3-.1.3-1.8.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m37.3 19.5.9.3q.2-.3 0-.4.2.1.4 0l.2-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m37 20.3 2.2-.7v.2l-2.1.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M41.8 19.3s.1.4.3.3l.2-.2s.1.4.3.3q.3-.2.3-.4h.3l.1-.5zm-.2 3 .3.2.2-.1q-.1.2.4.2.4-.3.3-.4l.1.2q.5-.2.5-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M37.1 19.4v.3L39 19v-.2l-1.8.6Zm2.3-.4 1.7-.7v.3l-1.6.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m41.6 20.3-.1.8q0 .8.2.9s.3-.7.6-.7.9.4.9.4v-1.1q.2-.8.4-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M39.3 19.7v.3l2.2-.6v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6b4",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m36.4 23.4-.5.1.3.4.1.4q.3 0 .3-.2v-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M39.3 22v.1l2-.3-.1-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M37.1 22.3q0 .2.2.2l.3-.2q0 .2.3.3.5-.2.5-.4 0 .2.2.2.3-.2.2-.3l-1.6.2zm0-1.8q-.1-.1-.2.6l.3.9s.3-.5.6-.6.9.3.9.3v-1q0-.5.3-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M41.5 22v.3l2-.4-.1-.2-1.9.4Zm0-1.9v.2l2.2-.7v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m45.2 22.7-1.6-3m-.2 2v-1.9m-1.7-.7v.2l1.7-.5v-.1c-.1 0-1.6.5-1.7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M39.4 19c.1 0 .3.4.4.3l.3-.2.2.3q.3-.1.2-.3h.3l.2-.6-1.6.6Zm0 1q-.2.1-.2 1l.3.8s.4-.5.7-.5c.4-.1.9.3.8.3l-.1-.8c0-.4.4-1.4.4-1.4zm0 2.1q0 .2.3.3l.2-.2q0 .2.2.3.4-.2.4-.4l.3.1c.2 0 .5-.4.5-.4s-1.9.4-2 .3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be0f17",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M39.6 21h.1v.3h-.2V21zm1-.3v.3h-.2v-.3zm-.6.6h.2v.3H40zm0-.9h.2v.2l-.1.1H40z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m40.3 18 .8.4L44 23m-1.4-4.5.7.4.2.7M38 18.4l.8.7.1.6m-3.8 3.1c.4-.1 3-2.7 3-2.7m-3.6 2.2 2.8-2.8m2 .5 2.6 5.2m-.3-3s.3 1.2.6 1.3l.7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M41.6 22.2s.2 1.4.5 1.7l.6.6m-3.3-2.4s.3 2 1 2.5l1 .9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M39.4 22.1s.6 1.6 1.2 2c.6.6 1.4 1 1.4 1m-4.8-2.9.3 1.4.6.8m-.9-2.1.6 1.3c.1.3 1.5 1.8 1.5 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M38.8 25.5v.2h-.3v-.3l.1-.1h.2zm1 .5v.2h-.3v-.3h.2zm1.2.1v.2h-.3V26h.2zm1-.4v.1l-.2-.1.1-.2q.2 0 .2.2Zm1-.6a.2.2 0 0 1-.4 0 .2.2 0 0 1 .4 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "m37.9 18.5-1.2.4 1.2.2zm2.2-.4-.8.3.9.2zm2.3.3s-1 .2-.8.3l.8.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M41.4 25.5c0-.5.8-3.3.8-3.3m-.5 3.2.6-3.1m-.3 2.9.4-3m-1 3 .6-.3m-.3-.3.3-.1m-.3-.2.4-.2m-.3-.3h.4m-.2-.4h.3M42 23h.3m-3.1 2.9c0-.5.8-3.4.8-3.4m-.5 3.4.6-3.4m-.4 3.4.5-3.4m-1 3 .6-.3m-.4-.3h.4m-.3-.3.4-.2m-.4-.3.5-.1m-.3-.3h.3m-.2-.4h.3m-.9 2.3c0-.5-.8-3.3-.8-3.3m.5 3.2-.6-3.2m.4 3-.5-3m1 3-.6-.3m.4-.3h-.4m.3-.3-.4-.2m.4-.3h-.5m.3-.4h-.3m.2-.4h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M42.8 24.2h2.5V24h-2.5zm.1-.8 2.5-.5v-.3l-2.5.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be0f17",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.1,
    d: "M40 20.8h.2v.3H40V21Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.3 0H27v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.5 0 10.1 7.5L23.7 0H27v2.6L17 10l10 7.5V20h-3.3l-10-7.5-10 7.5H.3v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H.3zM27 0v.1L16.6 8l.1-1.9L25 0zM.3 0l10 7.3H7.8L.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4 0v20H17V0zM.4 6.7v6.6H27V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.3 8v4H27V8zm11.4-8v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.5,
    x2: 20.5,
    y1: 47.4,
    y2: 46.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 36,
    x2: 33.4,
    y1: 28,
    y2: 26.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 37.2,
    x2: 31.9,
    y1: 29,
    y2: 28.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 47.2,
    x2: 44.7,
    y1: 26.5,
    y2: 26.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 48.5,
    x2: 43.2,
    y1: 28,
    y2: 28.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 47.7,
    x2: 33,
    y1: 29.7,
    y2: 29.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 33.3,
    x2: 54.7,
    y1: 30.9,
    y2: 30.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 48.5,
    x2: 46.7,
    y1: 29.4,
    y2: 29.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 33,
    x2: 34.7,
    y1: 31.5,
    y2: 31.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 34.2,
    x2: 31.1,
    y1: 31,
    y2: 30.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk);
export default __webpack_public_path__ + "static/media/fk.4a596330a2940a1454de9abaded49f8d.svg";
export { ForwardRef as ReactComponent };